import learningApi from '@src/services/api/learning/index'

const SESSION_EXPIRED = 'SESSION_EXPIRED'

const triggerBlobDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  window.URL.revokeObjectURL(url)
  link.remove()
}

const parseFilename = (xhr, defaultFilename) => {
  try {
    const contentDisposition = xhr.getResponseHeader('Content-Disposition')
    if (!contentDisposition) return defaultFilename
    let filename = defaultFilename
    contentDisposition.split(';').forEach((item) => {
      if (item.includes('filename=')) {
        filename = item.split('=')[1].replace(/"/g, '')
      }
    })
    return filename
  } catch (e) {
    console.error('filename error', e)
    return defaultFilename
  }
}

const requestPdf = (traineeId, path, defaultFilename, isRetry = false) => {
  const accessToken = learningApi.accessToken?.value
  if (!accessToken) {
    return learningApi.forceLogout(new Error('No access token'))
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', `${LEARNING_API_ENDPOINT}/my/user/trainees/${traineeId}/${path}`, true)
    xhr.setRequestHeader('authorization', `Bearer ${accessToken}`)
    xhr.responseType = 'blob'
    xhr.onreadystatechange = function () {
      if (this.readyState !== XMLHttpRequest.DONE) return

      if (this.status >= 200 && this.status < 300) {
        triggerBlobDownload(this.response, parseFilename(xhr, defaultFilename))
        resolve()
        return
      }

      if (this.status === 401) {
        if (!isRetry) {
          learningApi.ensureFreshAccessToken()
            .then(() => requestPdf(traineeId, path, defaultFilename, true))
            .then(resolve)
            .catch(reject)
          return
        }
        learningApi.forceLogout(new Error('Unauthorized'))
          .catch(reject)
        return
      }

      console.error('PDF download error', this.status)
      window.alert('PDFのダウンロードに失敗しました。')
      reject(new Error(`PDF download failed: ${this.status}`))
    }
    xhr.onerror = function (error) {
      console.error('PDF download error', error)
      window.alert('PDFのダウンロードに失敗しました。')
      reject(error)
    }
    xhr.send()
  })
}

const downloadPdf = (traineeId, path, defaultFilename) => {
  return learningApi.ensureFreshAccessToken()
    .then(() => requestPdf(traineeId, path, defaultFilename))
    .catch((error) => {
      if (error?.message === 'Session expired' || error?.message === 'Unauthorized') {
        return Promise.reject({ code: SESSION_EXPIRED })
      }
      return Promise.reject(error)
    })
}

export const downloadBill = (traineeId) => downloadPdf(traineeId, 'bill', 'bill.pdf')

export const downloadReceipt = (traineeId) => downloadPdf(traineeId, 'receipt', 'receipt.pdf')

export const downloadCert = (traineeId) => downloadPdf(traineeId, 'cert', 'certificate.pdf')

export const downloadTraineePdf = (type, traineeId) => {
  switch (type) {
    case 'bill':
      return downloadBill(traineeId)
    case 'receipt':
      return downloadReceipt(traineeId)
    case 'cert':
      return downloadCert(traineeId)
    default:
      return Promise.reject(new Error(`Unknown PDF type: ${type}`))
  }
}

export const isSessionExpiredPdfError = (error) => error?.code === SESSION_EXPIRED
